module.exports = __webpack_public_path__ + "static/media/home-with-background.c1a1dca3.jpg";